module.exports = __webpack_public_path__ + "assets/img/zgyhzq.b2a43046.png";